<template>
  <tabs>
    <tab title="Products">
      <div class="m-3" style="height: 400px">
        <OrderProductTable 
          v-if="order.details && phase3d_care_app != null" 
          :details="order.details" 
          :phase3d_care_app="phase3d_care_app"
          />
      </div>
    </tab>

    <tab title="Tracking">
      <div class="m-3" style="height: 400px">
        <OrderTrackingTable />
      </div>
    </tab>
    <tab title="Discounts">
      <div class="m-3" style="height: 400px">
        <OrderDiscountsTable 
          v-if="phase3d_care_app != null"
          :phase3d_care_app="phase3d_care_app"/>
      </div>
    </tab>
  </tabs>
</template>

<script>
import Tab from "@/components/elements/Tab.vue";
import Tabs from "@/components/elements/Tabs.vue";
import OrderProductTable from "./OrderProductTable.vue";
import OrderTrackingTable from "./OrderTrackingTable.vue";
import OrderDiscountsTable from "./OrderDiscountsTable.vue";
import { ApiFactory } from "@/api/ApiFactory.js";

export default {
  name: "OrderDetails",
  components: {
    OrderDiscountsTable,
    Tab,
    Tabs,
    OrderProductTable,
    OrderTrackingTable,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      phase3d_care_app: null,
    }
  },
  async created () {
    const response = await ApiFactory.get("feature-flags").isFeatureFlagEnabled("phase3d_care_app");
    this.phase3d_care_app = response.data.body.enabled;
  },
};
</script>
